import React, { useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { loginStart, loginSuccess, loginFailure } from '../../components/redux/user/UserSlice';
import { ToastContainer, toast } from "react-toastify"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faLock } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import './Login.css';

function Login() {
  const [loading, error] = useSelector((state) => [state.user.loading, state.user.error]);
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({});
  let navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { email, password } = formData;
  
    try {
      dispatch(loginStart());
  
      const response = await fetch(`${process.env.REACT_APP_ORIGIN_URL}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email,
          password,
        }),
      });
  
      if (!response.ok) {
        throw new Error('Login failed');
      }
  
      const result = await response.json(); // Parse the response

       if (result.data.user.user_role === "patient") {
            toast.error("Access restricted: Only doctors are allowed to log in.");
            dispatch(loginFailure("Access restricted: Only doctors are allowed to log in."));
            return;
          }
  
      // Store `token` and `id` in local storage
      localStorage.setItem('token', result.data.token);
      localStorage.setItem('id', result.data.user.id);
  
      // Dispatch login success with the correct payload structure
      dispatch(loginSuccess(result)); // Pass the entire API response

      navigate('/homepage');
    } catch (error) {
      dispatch(loginFailure(error.message));
    }
  };
  
  return (
    <div className="login-body">
        <ToastContainer
                    position="top-right"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="colored"
                  />
      <div className="main-login d-flex align-items-center justify-content-center h-100">
        <div className="login-page-bg shadow-lg">
          <div className="brand-logo text-center">
            <h2>eHealth Jamaica Meeting Portal</h2>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="login-inputs d-flex align-items-center justify-content-center flex-column">
              <div className="input-group mb-3">
                <span className="input-group-text" style={{height:"47px",backgroundColor:"#44A08D",}}>
                  <FontAwesomeIcon icon={faUser} />
                </span>
                <div className="form-floating">
                  <input 
                    type="text" 
                    className="form-control" 
                    id="email" 
                    placeholder="Username" 
                    onChange={handleChange}
                  />
                  <label htmlFor="email">Username</label>
                </div>
              </div>
              <div className="input-group flex-nowrap">
                <div className="input-group mb-3">
                  <span className="input-group-text" style={{height:"47px",backgroundColor:"#44A08D",}}> 
                    <FontAwesomeIcon icon={faLock} />
                  </span>
                  <div className="form-floating">
                    <input 
                      type="password" 
                      className="form-control" 
                      id="password" 
                      placeholder="Password" 
                      onChange={handleChange}
                    />
                    <label htmlFor="password">Password</label>
                  </div>
                </div>
              </div>
              <div className="btn-signin shadow-sm">
                <button 
                  type="submit" 
                  className="btn btn-signin" 
                  style={{fontWeight:"bold"}}
                  disabled={loading} // Disable button while loading
                >
                  {loading ? "Loading..." : "Sign In"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
     
          
    </div>
  );
}

export default Login;